import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1bd8086f")

_pushScopeId("data-v-1bd8086f")
const _hoisted_1 = { class: "p-d-flex p-jc-between p-py-2" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { style: {"overflow-x":"auto"} }
const _hoisted_5 = { class: "p-text-truncate-2" }
const _hoisted_6 = { class: "p-text-truncate-2" }
const _hoisted_7 = {
  key: 0,
  class: "p-text-truncate-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "p-d-flex p-jc-center p-ai-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ExperimentStatus = _resolveComponent("ExperimentStatus")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_NewPrediction = _resolveComponent("NewPrediction")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("h5", null, _toDisplayString(_ctx.$t("automl.prediction.board.title")), 1),
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.search_key,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search_key = $event)),
          style: {"width":"25rem"},
          placeholder: _ctx.$t('automl.prediction.board.search.place.holder'),
          onInput: _ctx.search
        }, null, 8, ["modelValue", "placeholder", "onInput"])
      ]),
      (_ctx.canEdit())
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            icon: "pi pi-plus",
            style: {"float":"right"},
            label: _ctx.$t('button.create_prediction'),
            onClick: _ctx.onClickCreate
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_DataTable, {
        removableSort: "",
        loading: _ctx.loading,
        value: _ctx.predictions,
        "sort-field": _ctx.sortBy,
        "sort-order": _ctx.sortOrder
      }, {
        empty: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("datasource.sample_data.no.data.found")), 1)
        ]),
        loading: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("datasource.sample_data.loading.data.please.wait")), 1)
        ]),
        footer: _withId(() => [
          (_ctx.hasMorePrediction())
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('button.more'),
                  class: "p-button-text",
                  onClick: _ctx.loadNextPredictions
                }, null, 8, ["label", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          _createVNode(_component_Column, {
            field: "name",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.predictionName'),
            sortable: true
          }, {
            body: _withId(({ data }) => [
              _withDirectives(_createVNode("div", _hoisted_5, [
                _createVNode("span", null, _toDisplayString(data.name), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  data.name,
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "modelName",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.modelName')
          }, {
            body: _withId(({ data }) => [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", null, _toDisplayString(data.modelName), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "fileInputName",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.fileName'),
            sortable: true
          }, {
            body: _withId(({ data }) => [
              (data.fileInputName)
                ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.getFileName(data)), 1)
                  ], 512)), [
                    [
                      _directive_tooltip,
                      _ctx.getFileName(data),
                      void 0,
                      { top: true }
                    ]
                  ])
                : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("automl.prediction.board.nodata")), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "numberRecord",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.numberOfRecord')
          }, {
            body: _withId(({ data }) => [
              _createVNode("span", null, _toDisplayString(data.numberRecord), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "predictionTime",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.predictionTime')
          }, {
            body: _withId(({ data }) => [
              (data.predictionStatus === 'COMPLETED')
                ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$moment.duration(data.predictionTime, "seconds").humanize()), 1)
                  ], 512)), [
                    [_directive_tooltip, `${_ctx.$getDuration(data.predictionTime)}`]
                  ])
                : (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.$t("automl.prediction.board.nodata")), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "explanationTime",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.explainationTime')
          }, {
            body: _withId(({ data }) => [
              (data.runExplain && data.explainStatus === 'COMPLETED')
                ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$moment.duration(data.explanationTime, "seconds").humanize()), 1)
                  ], 512)), [
                    [_directive_tooltip, `${_ctx.$getDuration(data.explanationTime)}`]
                  ])
                : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("automl.prediction.board.nodata")), 1))
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "predictionOutput",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.predictionResult')
          }, {
            body: _withId(({ data }) => [
              _createVNode("div", _hoisted_13, [
                (data.predictionStatus === 'COMPLETED')
                  ? (_openBlock(), _createBlock("span", _hoisted_14, [
                      _withDirectives(_createVNode(_component_Button, {
                        label: _ctx.$t('automl.prediction.board.download'),
                        onClick: ($event: any) => (_ctx.downloadPrediction(data.id)),
                        class: "p-button-link p-p-0"
                      }, null, 8, ["label", "onClick"]), [
                        [
                          _directive_tooltip,
                          data.predictionOutput,
                          void 0,
                          { top: true }
                        ]
                      ])
                    ]))
                  : (data.predictionStatus)
                    ? (_openBlock(), _createBlock("span", _hoisted_15, [
                        _createVNode(_component_ExperimentStatus, {
                          status: data.predictionStatus
                        }, null, 8, ["status"])
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_16, [
                        _createVNode(_component_ExperimentStatus, { status: 'RUNNING' })
                      ]))
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "explainOutput",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.explaination')
          }, {
            body: _withId(({ data }) => [
              _createVNode("div", _hoisted_17, [
                (data.runExplain)
                  ? (_openBlock(), _createBlock("span", _hoisted_18, [
                      (data.explainStatus === 'COMPLETED')
                        ? (_openBlock(), _createBlock("span", _hoisted_19, [
                            _withDirectives(_createVNode(_component_Button, {
                              label: _ctx.$t('automl.prediction.board.download'),
                              onClick: ($event: any) => (_ctx.downloadExplaination(data.id)),
                              class: "p-button-link p-p-0"
                            }, null, 8, ["label", "onClick"]), [
                              [
                                _directive_tooltip,
                                data.explainOutput,
                                void 0,
                                { top: true }
                              ]
                            ])
                          ]))
                        : (data.explainStatus)
                          ? (_openBlock(), _createBlock("span", _hoisted_20, [
                              _createVNode(_component_ExperimentStatus, {
                                status: data.explainStatus
                              }, null, 8, ["status"])
                            ]))
                          : (_openBlock(), _createBlock("span", _hoisted_21, [
                              _createVNode(_component_ExperimentStatus, { status: 'RUNNING' })
                            ]))
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("automl.prediction.board.nodata")), 1))
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "createdDate",
            key: "id",
            header: _ctx.$t('automl.prediction.board.headers.created'),
            sortable: true
          }, {
            body: _withId(({ data }) => [
              _withDirectives(_createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t("label.created_date_and_by_username", {
              time: _ctx.$moment(data.createdDate).fromNow(),
              user: _ctx.getFullname(data.createdBy),
            })), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  _ctx.$moment(data.createdDate).format('LLLL'),
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          (_ctx.canEdit())
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                headerStyle: "width: 5rem; text-align: center",
                bodyStyle: "overflow: visible;",
                bodyClass: "p-jc-center"
              }, {
                body: _withId(({ data }) => [
                  _withDirectives(_createVNode(_component_Button, {
                    class: "p-button-rounded p-button-secondary p-button-text",
                    icon: "pi pi-trash",
                    onClick: ($event: any) => (_ctx.confirmDeletePrediction($event, data))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('button.delete'),
                      void 0,
                      { top: true }
                    ]
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading", "value", "sort-field", "sort-order"])
    ]),
    (_ctx.displayNewPrediction)
      ? (_openBlock(), _createBlock(_component_NewPrediction, {
          key: 0,
          onClicked: _ctx.offDialog,
          workspaceId: _ctx.workspaceId
        }, null, 8, ["onClicked", "workspaceId"]))
      : _createCommentVNode("", true)
  ], 64))
})